/**
 * Short order number for receipts (e.g. "26-1002-1" → "#001").
 */
export function formatReceiptOrderNumber(orderNumber, fallbackId) {
  const source = orderNumber || (fallbackId ? String(fallbackId) : "");
  if (!source) return "—";

  const segment = source.includes("-") ? source.split("-").pop() : source;
  const cleaned = String(segment).trim();
  if (!cleaned) return "—";

  if (/^\d+$/.test(cleaned)) {
    return `#${cleaned.padStart(3, "0")}`;
  }

  return `#${cleaned}`;
}
